<div class="calculator-change-diloag add-payment p-0">
  <div class="dialog-header ui-g-12 p-zero">
    <div [class]="data.styleClassHeading" [ngClass]="{ 'calculator-change-heading mb-0': true }">Calculate Change</div>
    <i class="fal fa-times close-icon pointer dialog-close" (click)="closeDialog(false, 'cancel')"></i>
  </div>

  <div class="dialog-body calculator-change-content font-12 flex-column">
    <div class="ui-g-12 p-0">
      <p class="mb-1">Cash received</p>
      <div class="calculator-field">
        <app-input id="cach-receivedId" [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
          [allowDecimal]="focus?.collectedAmount ? true : false" [autoFocus]="focus.collectedAmount" theme="border"
          leftIcon="fal fa-hand-holding-usd" placeholder="Enter the value" [autoFocus]="true" (appFocus)="handleFocus()"
          (appEnter)="validation()" (appBlur)="validation()"
          [value]="focus.collectedAmount ? amount : (amount | currency : 'USD')"
          (appChange)="handleChange($event)"></app-input>
        <button [disabled]="!amount" class="btn btn-tranparent" (click)="validation()">Calculate</button>
      </div>

      <label id="cash-payment-validation-amount" class="pt-1 error-label" *ngIf="validate.amount">
        {{ validate.amount }}
      </label>
    </div>

    <div class="ui-g-12 pt-3 p-0">
      <p class="mb-1">Change</p>
      <div class="change-color-gray">
        <app-input theme="border" id="idChange-remaining-amount" leftIcon="fal fa-sack-dollar" placeholder=""
          readOnly="true" [value]="change | currency : usd"></app-input>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer text-right">
    <button id="change-dialog-btn-cancel" (click)="closeDialog(false, 'cancel')"
      class="btn btn-white btn-border pointer btn-submit mr-2">Close</button>
  </div>
</div>
